// src/services/internalRegulationService.js
import { fetchWithAuth } from '../utils/fetchWithAuth';

const BASE = '/internal-regulation';

/* -------- helpers -------- */
const jsonOrThrow = async (res) => {
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg =
      (data && (data.message || data.error || data.detail)) ||
      `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
};

// Acepta Date | string | null | undefined y devuelve ISO o null
const toISOorNull = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

/* ===== Docs ===== */
export async function listIRDocs(publishedOnly) {
  const q = publishedOnly ? '?publishedOnly=true' : '';
  const res = await fetchWithAuth(`${BASE}${q}`);
  const arr = await jsonOrThrow(res);
  return Array.isArray(arr)
    ? arr.map((m) => ({
        id: m.id || m._id,
        title: m.title,
        versionTag: m.versionTag,
        isPublished: !!m.isPublished,
        createdAt: m.createdAt,
        secureUrl: m.secureUrl,
        coverUrl: m.coverUrl || null, // portada generada (opcional)
      }))
    : [];
}

export async function getLatestIRDoc() {
  const res = await fetchWithAuth(`${BASE}/latest`);
  const m = await jsonOrThrow(res);
  if (!m) return null;
  return {
    id: m.id || m._id,
    title: m.title,
    versionTag: m.versionTag,
    isPublished: !!m.isPublished,
    createdAt: m.createdAt,
    secureUrl: m.secureUrl,
    coverUrl: m.coverUrl || null,
  };
}

export function downloadIRDocUrl(id) {
  return `${BASE}/${encodeURIComponent(id)}/download`;
}

export async function uploadIRDoc({ file, title, versionTag, isPublished = true }) {
  const fd = new FormData();
  fd.append('file', file);
  if (title) fd.append('title', title);
  if (versionTag) fd.append('versionTag', versionTag);
  fd.append('isPublished', String(!!isPublished));
  const res = await fetchWithAuth(`${BASE}/upload`, { method: 'POST', body: fd });
  return jsonOrThrow(res);
}

export async function updateIRDoc(id, body) {
  const res = await fetchWithAuth(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  return jsonOrThrow(res);
}

export async function deleteIRDoc(id) {
  const res = await fetchWithAuth(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
  return jsonOrThrow(res);
}

/* ===== Config ===== */
export async function getIRConfig() {
  const res = await fetchWithAuth(`${BASE}/config`);
  return jsonOrThrow(res);
}

export async function updateIRConfig(body) {
  // normaliza lastVisibleAt si viene como Date
  const payload = { ...(body || {}) };
  if ('lastVisibleAt' in payload) {
    payload.lastVisibleAt = toISOorNull(payload.lastVisibleAt);
  }
  const res = await fetchWithAuth(`${BASE}/config`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}

/* ===== Content ===== */
export async function getIRContent() {
  const res = await fetchWithAuth(`${BASE}/content`);
  return jsonOrThrow(res);
}

export async function updateIRContent(body) {
  const res = await fetchWithAuth(`${BASE}/content`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  return jsonOrThrow(res);
}
